import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@carm/shared/shared.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateModule } from '@ngx-translate/core';
import { SessionTimeoutComponent } from './component/session-timeout.component';
import { SessionTimeoutService } from './services/session-timeout.service';
import { TimeoutModalComponent } from './timeout-modal/timeout-modal.component';

@NgModule({
  declarations: [
      TimeoutModalComponent,
      SessionTimeoutComponent,
  ],
  imports: [
      CommonModule,
      SharedModule,
      TranslateModule,
      NgIdleKeepaliveModule.forRoot(),
  ],
  providers: [
      SessionTimeoutService,
  ],
  exports: [
      TimeoutModalComponent,
      SessionTimeoutComponent,
  ]
})
export class SessionTimeoutModule { }
